export function Footer() {
	return (
		<footer className="pt-2 pb-5 text-xs font-medium md:mx-12">
			<div className="flex w-full items-center justify-center md:justify-between">
				<div className="text-muted-foreground hidden justify-between md:flex">
					<div>© 2025 Lydra AI</div>
				</div>
				<div className="flex items-center justify-center gap-3">
					<a className="underline" href="/privacy">
						Privacy
					</a>
					<a className="underline" href="/terms-of-service">
						Terms
					</a>
					<a
						className="underline"
						rel="noopener noreferrer"
						href="mailto:support@lydra.ai"
					>
						Contact
					</a>
				</div>
			</div>
			<div className="text-muted-foreground mt-3 mb-1.5 text-center md:hidden">
				© 2025 Lydra AI
			</div>
		</footer>
	)
}
